
















import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import DropdownSelect from '../../atoms/DropdownSelect.vue'
import { SelectItem } from '../../atoms/model/SelectItem'

@Component({
  components: {
    DropdownSelect,
  },
})
export default class MonthDropdownSelect extends Vue {
  /**
   * disabled項目が（初期表示時に）選択されている可能性をnullとして表現している。
   */
  @Prop({ default: null })
  value: number | null

  @Prop({
    // default: 全ての要素を有効とする
    default: () => (() => false),
  })
  disableFilter: (month: number) => boolean

  get monthList(): SelectItem[] {
    return [
      {
        text: '',
        value: '',
        selected: this.value === null,
        disabled: true,
      },
      // tslint:disable-next-line:no-magic-numbers
      ..._.range(1, 13).map((year: number) => ({
        value: `${year}`,
        text: `${year}`,
        selected: year === this.value,
        disabled: this.disableFilter ? this.disableFilter(year) : false,
      })),
    ]
  }

  onInput(value) {
    this.$emit('input', value)
  }
}
